<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{$t('apiDoc.在线文档')}}</span>
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'order/returnAndExchange';
export default {
  components: { onlineDoc , apiTestDoc },
  name: 'returnAndExchange',
  data() { 
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述 退换货下单接口
        apiDesc: `${this.$t('onlineDoc.OrderDescription_9')}`,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[
            
        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳，毫秒')}`},
                    ]
            },
             { 
                title:`${this.$t('onlineDoc.请求参数')}`, 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
                ]
            },
            {
              title:`${this.$t('onlineDoc.业务参数')}`,
              value:[
                {name: "customerCode",type: "String(30)",require: "Y",normal: "J0086474299",describe: `${this.$t('onlineDoc.客户编码（订单类型传2时，必填）')}`},
                {name: "digest",type: "String(50)",require: "Y",normal: `${this.$t('onlineDoc.明文密码:H5CD3zE6')}`,describe: `${this.$t('onlineDoc.sign')}`},
                {name: "billCode",type: "String(50)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.客户订单号（传客户自己系统的订单号）')}`},
                {name: "returnAndExchangeType",type: "String(50)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.退换货')}`},
                {name: "itemDescription",type: "String(50)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.物品描述')}`},
              ]
            }

        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:`${this.$t('onlineDoc.响应参数')}`,
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码，见附录')}`},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务数据')}`}
                  ]
            },
            {
              title:`${this.$t('onlineDoc.data类型说明')}`,
              value:[
                  {name: "billCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.客户订单号')}`},
                  {name: "returnBillCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.退货单单号')}`},
                  {name: "exchangeBillCode",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.换货单单号')}`}
                ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=292508153084379141
    digest=bIN6a2l07XweEKRizSHS9g==
    timestamp=1645775620879

Body：
    bizContent="{'customerCode': 'J0086024131', 'digest': 'RWIAZ2GAye1tpCl0NwuURw==', 'billCode': '01', 'returnAndExchangeType': '2', 'itemDescription': '04'}"`,
        //返回示例
        responseCode: JSON.parse(`{"code":"1","msg":"success","data":{"returnBillCode":"UAT000000001","billCode":"01","exchangeBillCode":"UAT000000002"}}`),

       //错误代码提示
        errcodeJson: []
      },

      apiTestData: {
          _headerData: {
            apiAccount: "292508153084379141",
            digest: "bIN6a2l07XweEKRizSHS9g==",
            timestamp: "1645775620879",
          },
          data:{
             bizContent: `{'customerCode': 'J0086024131', 'digest': 'RWIAZ2GAye1tpCl0NwuURw==', 'billCode': '01', 'returnAndExchangeType': '2', 'itemDescription': '04'}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
       //错误代码提示
        errcodeJson: []
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>